import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

// Pill buttons with labels, as in the design.
const STEP = 'tw-inline-flex tw-items-center tw-gap-1 tw-rounded-full tw-border tw-border-neutral-300 tw-bg-white tw-px-3 tw-py-1 tw-text-sm tw-font-medium tw-text-neutral-700 hover:tw-bg-neutral-50 hover:tw-text-neutral-900 focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-brand-300 disabled:tw-cursor-not-allowed disabled:tw-opacity-40 disabled:hover:tw-bg-white';

/**
 * Prev / Next through the program's registrations, in the registration list's order
 * (`booking/programbookingneighbors`). `neighbors` is that endpoint's result.
 *
 * Renders nothing until it has loaded, when the booking isn't in the list (e.g. payment pending,
 * so `position` is null), or when it is the only one.
 */
const PrevNextNav = ({ neighbors, onGo }) => {
    if (!neighbors?.position || neighbors.total <= 1) return null;
    const { prev, next, position, total } = neighbors;

    return (
        <nav aria-label="Program registrations" className="tw-flex tw-items-center tw-gap-2">
            <button type="button" className={STEP} disabled={!prev} onClick={() => onGo(prev)} title="Previous registration">
                <ChevronLeft className="tw-h-4 tw-w-4" aria-hidden="true" /> Prev
            </button>
            <span className="tw-px-1 tw-text-center tw-text-sm tw-tabular-nums tw-text-neutral-500">{position} of {total}</span>
            <button type="button" className={STEP} disabled={!next} onClick={() => onGo(next)} title="Next registration">
                Next <ChevronRight className="tw-h-4 tw-w-4" aria-hidden="true" />
            </button>
        </nav>
    );
};

export default PrevNextNav;
